'use-client';
import * as React from 'react';
import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import ResponsiveContainer from '@wix/thunderbolt-elements/components/ResponsiveContainer';
import type { IMegaMenuContainerDropdownProps } from '../../../MegaMenuContainerItem.types';
import { DropdownWrapper } from '../../../../Menu/viewer/components/DropdownWrapper/DropdownWrapper';
import styles from './Dropdown.module.scss';
import cn from 'clsx';
import { semanticClassNames as megaMenuContainerItemSemanticClassNames } from '../../../MegaMenuContainerItem.semanticClassNames';

const MegaMenuContainerItem: React.FC<
  IMegaMenuContainerDropdownProps
> = props => {
  const {
    id,
    className,
    children,
    containerRootClassName,
    menuOrientation,
    customClassNames = [],
    isClassNameToRootEnabled,
  } = props;
  const childrenToRender =
    typeof children === 'function' ? children : () => children;

  const childrenWrapperClassName = cn(
    styles.childrenWrapper,
    styles.childrenWrapperDirection,
    styles.physicalLayout,
    containerRootClassName,
    formatClassNames(
      megaMenuContainerItemSemanticClassNames.dropdownContainer,
      ...customClassNames,
    ),
  );

  return (
    <DropdownWrapper
      id={id}
      dataAttributes={getDataAttributes(props)}
      childrenWrapperClassName={childrenWrapperClassName}
      menuOrientation={menuOrientation}
      {...(isClassNameToRootEnabled && { className })}
    >
      <ResponsiveContainer {...props.containerProps}>
        {childrenToRender}
      </ResponsiveContainer>
    </DropdownWrapper>
  );
};

export default MegaMenuContainerItem;
